
// import {
//   FaBalanceScale,
//   FaGlobeAsia,
//   FaBookOpen,
//   FaCalendarAlt,
//   FaArrowRight,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";

// const benefits = [
//   {
//     icon: <FaBalanceScale />,
//     title: "Policy Advocacy",
//   },
//   {
//     icon: <FaGlobeAsia />,
//     title: "Global Network",
//   },
//   {
//     icon: <FaBookOpen />,
//     title: "Knowledge Hub",
//   },
//   {
//     icon: <FaCalendarAlt />,
//     title: "Priority Events",
//   },
// ];

// export default function BecomeMember() {
//   return (
//     <section
//       className="relative overflow-hidden py-3 pt-3 pb-8"
//       style={{
//         backgroundImage: `url('https://www.assocham.org/assocham_backend/assets/images/banner/membership-header.jpg')`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//       }}
//     >
//       {/* Dark Overlay for Readability */}
//       <div className="absolute inset-0 bg-gradient-to-r from-[#6A040F]/75 via-[#6A040F]/65 to-[#B42318]/70" />

//       {/* Subtle accent overlay matching theme */}
//       <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-transparent" />

//       {/* Decorative elements */}
//       <div className="absolute top-10 left-10 w-[300px] h-[300px] bg-[#ff8fab]/10 blur-[120px] rounded-full" />
//       <div className="absolute bottom-10 right-10 w-[280px] h-[280px] bg-[#f77f00]/10 blur-[100px] rounded-full" />

//       <div className="max-w-[1280px] mx-auto px-4 relative z-10">

//         {/* Heading Section */}
//         <div className="text-center max-w-[650px] mx-auto">

//           {/* <span className="uppercase tracking-[0.22em] text-[11px] font-semibold text-white/90 font-rethink">
//             JOIN THE NETWORK
//           </span> */}

//           <h2 className="mt-3 text-[26px] md:text-[32px] leading-tight font-semibold text-white font-rethink">
//             Become a{" "}
//             <span className="italic text-[#FFD23F]">Member</span>
//           </h2>

//           {/* <p className="mt-4 text-white/90 text-[15px] leading-relaxed font-rethink max-w-md mx-auto">
//             Unlock premium business opportunities, policy access
//             and strategic networks.
//           </p> */}

//         </div>

//         {/* Main Grid */}
//         <div className="grid lg:grid-cols-12 gap-6 mt-10 items-center">

//           {/* LEFT CARD */}
//           <div className="lg:col-span-5">
//             <div className="rounded-[26px] bg-white/95 backdrop-blur-xl border border-white/70 px-5 py-3 shadow-xl h-full">

//               {/* <span className="uppercase tracking-[0.18em] text-[11px] font-semibold text-[#B42318] font-rethink">
//                 Premium Membership
//               </span> */}

//               <div className="mt-5 flex flex-col md:flex-row gap-6 items-start">

//                 <h3 className="text-[19px] leading-tight font-semibold text-[#5C000B] font-rethink">
//                   Empowering India's
//                   <br />
//                   Business Future
//                 </h3>

//                 <div className="flex gap-3">
//                   <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6] flex-shrink-0">
//                     <h4 className="text-[#C1121F] text-[21px] font-bold font-rethink">
//                       4.5L+
//                     </h4>
//                     <p className="text-[#777] text-[11px] font-rethink">
//                       Members
//                     </p>
//                   </div>

//                   <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6] flex-shrink-0">
//                     <h4 className="text-[#C1121F] text-[21px] font-bold font-rethink">
//                       400+
//                     </h4>
//                     <p className="text-[#777] text-[11px] font-rethink">
//                       Events
//                     </p>
//                   </div>
//                 </div>
//               </div>

//                 <div className="button-div" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
//               <button className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#B42318] text-white text-[14px] font-medium hover:scale-[1.03] transition-all duration-300 shadow-lg font-rethink">
//                 <Link to='/membership'>
//                 Apply Membership
//                 <FaArrowRight className="text-[13px]" />
//                 </Link>
//               </button>
//               <Link to='/membership-plans'>
//               <button className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#B42318] text-white text-[14px] font-medium hover:scale-[1.03] transition-all duration-300 shadow-lg font-rethink">
//                 Benefits
//                 <FaArrowRight className="text-[13px]" />
//               </button>
//               </Link>
//               </div>

//             </div>
//           </div>

//           {/* RIGHT CARDS */}
//           <div className="lg:col-span-7">
//             <div className="grid grid-cols-2 gap-4">
//               {benefits.map((item, index) => (
//                 <div
//                   key={index}
//                   className="group rounded-[22px]
//                   bg-white/90 backdrop-blur-xl border border-white/60
//                   px-5 py-3 flex items-center gap-4
//                   shadow-lg hover:shadow-xl
//                   hover:-translate-y-1 transition-all duration-300"
//                 >
//                   <div
//                     className="w-12 h-12 rounded-2xl
//                     bg-gradient-to-br from-[#D62828] to-[#F77F00]
//                     text-white flex items-center justify-center text-[15px] shadow-md"
//                   >
//                     {item.icon}
//                   </div>

//                   <h3 className="text-[15.5px] font-medium text-[#5C000B] font-rethink">
//                     {item.title}
//                   </h3>
//                 </div>
//               ))}
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }







// new code 




import {
  FaBalanceScale,
  FaGlobeAsia,
  FaBookOpen,
  FaCalendarAlt,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const benefits = [
  {
    icon: <FaBalanceScale />,
    title: "Policy Advocacy",
  },
  {
    icon: <FaGlobeAsia />,
    title: "Global Network",
  },
  {
    icon: <FaBookOpen />,
    title: "Knowledge Hub",
  },
  {
    icon: <FaCalendarAlt />,
    title: "Priority Events",
  },
];

export default function BecomeMember() {
  return (
    <section
      className="relative overflow-hidden py-8 sm:py-10 lg:py-14"
      style={{
        backgroundImage: `url('https://www.assocham.org/assocham_backend/assets/images/banner/membership-header.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark Overlay for Readability — vertical on mobile, horizontal from md up */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-[#6A040F]/85 via-[#6A040F]/75 to-[#B42318]/80
        md:bg-gradient-to-r md:from-[#6A040F]/75 md:via-[#6A040F]/65 md:to-[#B42318]/70"
      />

      {/* Subtle accent overlay matching theme */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-transparent" />

      {/* Decorative elements — smaller & pulled off-canvas on mobile */}
      <div
        className="pointer-events-none absolute -left-10 -top-10 h-[180px] w-[180px] rounded-full bg-[#ff8fab]/10 blur-[90px]
        sm:left-10 sm:top-10 sm:h-[300px] sm:w-[300px] sm:blur-[120px]"
      />
      <div
        className="pointer-events-none absolute -bottom-10 -right-10 h-[160px] w-[160px] rounded-full bg-[#f77f00]/10 blur-[80px]
        sm:bottom-10 sm:right-10 sm:h-[280px] sm:w-[280px] sm:blur-[100px]"
      />

      <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        {/* Heading Section */}
        <div className="mx-auto max-w-[650px] text-center">
          <h2 className="text-[22px] font-semibold leading-tight text-white font-rethink sm:text-[26px] md:text-[32px] lg:mt-3">
            Become a <span className="italic text-[#FFD23F]">Member</span>
          </h2>
        </div>

        {/* Main Grid */}
        <div className="mt-7 grid grid-cols-1 gap-5 sm:mt-10 sm:gap-6 lg:grid-cols-12 lg:items-center">
          {/* LEFT CARD */}
          <div className="lg:col-span-5">
            <div
              className="rounded-[22px] border border-white/70 bg-white/95 px-5 py-6 shadow-xl backdrop-blur-xl
              sm:rounded-[26px] sm:px-6 sm:py-7"
            >
              <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:gap-6">
                <h3 className="text-[18px] font-semibold leading-tight text-[#5C000B] font-rethink sm:text-[19px]">
                  Empowering India's
                  <br className="hidden sm:block" /> Business Future
                </h3>

                <div className="grid w-full grid-cols-2 gap-3 sm:flex sm:w-auto sm:flex-shrink-0">
                  <div className="rounded-2xl border border-[#ffd6d6] bg-[#fff7f7] px-4 py-3 text-center sm:px-5 sm:text-left">
                    <h4 className="text-[19px] font-bold text-[#C1121F] font-rethink sm:text-[21px]">
                      4.5L+
                    </h4>
                    <p className="text-[11px] text-[#777] font-rethink">
                      Members
                    </p>
                  </div>

                  <div className="rounded-2xl border border-[#ffd6d6] bg-[#fff7f7] px-4 py-3 text-center sm:px-5 sm:text-left">
                    <h4 className="text-[19px] font-bold text-[#C1121F] font-rethink sm:text-[21px]">
                      400+
                    </h4>
                    <p className="text-[11px] text-[#777] font-rethink">
                      Events
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex flex-col gap-3 sm:mt-7 sm:flex-row sm:flex-wrap">
                <Link
                  to="/membership"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#B42318] px-6 py-3.5
                  text-[14px] font-medium text-white shadow-lg transition-all duration-300
                  hover:scale-[1.03] active:scale-[0.98] font-rethink sm:w-auto sm:px-7"
                >
                  Apply Membership
                  <FaArrowRight className="text-[13px]" />
                </Link>

                <Link
                  to="/membership-plans"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#B42318] px-6 py-3.5
                  text-[14px] font-medium text-white shadow-lg transition-all duration-300
                  hover:scale-[1.03] active:scale-[0.98] font-rethink sm:w-auto sm:px-7"
                >
                  Benefits
                  <FaArrowRight className="text-[13px]" />
                </Link>
              </div>
            </div>
          </div>

          {/* RIGHT CARDS */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
              {benefits.map((item, index) => (
                <div
                  key={index}
                  className="group flex items-center gap-3 rounded-[18px] border border-white/60 bg-white/90 px-4 py-3.5
                  shadow-lg backdrop-blur-xl transition-all duration-300
                  hover:-translate-y-1 hover:shadow-xl sm:gap-4 sm:rounded-[22px] sm:px-5 sm:py-3"
                >
                  <div
                    className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl
                    bg-gradient-to-br from-[#D62828] to-[#F77F00] text-[15px] text-white shadow-md
                    sm:h-12 sm:w-12"
                  >
                    {item.icon}
                  </div>

                  <h3 className="text-[14.5px] font-medium leading-snug text-[#5C000B] font-rethink sm:text-[15.5px]">
                    {item.title}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}